import React, { useState } from "react";
import { articlesData } from "./articlesData";
import SubscribeSection from "./subscribeSection";
import Categories from "./categories";
import ArticleCard from "./articleCard";
import "./blog.css";
import Footer from "../components/footer";
import HomeHeader from "../home/new/components/homeHeader";

// need to make responsive

const BlogPage = () => {
  const [category, setCategory] = useState("All");
  const filteredArticles =
    category === "All"
      ? articlesData
      : articlesData.filter((article) => article.category === category);

  return (
    <div>
      <HomeHeader
        isTitle={false}
        title={""}
        headerColor="header-white"
        navItems={true}
      />
      <div className="main-container">
        <SubscribeSection />
        <Categories setCategory={setCategory} />
        <div className="article-grid">
          {filteredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogPage;
